// Client-side revival of the dead UserSessionController.userAgentParser
// Java method (defined but never called server-side). UserSession.device
// stores the raw browser User-Agent string, which is too granular to group
// sessions by directly (a single physical browser spawns a "new device"
// on every point-release bump) - this normalizes it into a stable label
// purely for display/grouping, without touching how sessions are created.
export function parseDeviceInfo(userAgentString) {
    if (!userAgentString) {
        return { device: "?", os: "", browser: "", groupKey: "unknown", label: "?" };
    }

    const parts = userAgentString.split(/[()\s;]/).filter(Boolean);
    let device = "?";
    let os = "";
    let browser = "";

    for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        if (/^(Windows|Win64|x64)$/i.test(part)) {
            device = "Windows PC";
        } else if (/^iPhone$/i.test(part)) {
            device = "iPhone";
        } else if (/^iPad$/i.test(part)) {
            device = "iPad";
        } else if (/^Mac$/i.test(part)) {
            device = "Mac";
        } else if (/^Linux$/i.test(part)) {
            device = "Linux PC";
        } else if (/^Android$/i.test(part)) {
            device = "Android";
        } else if (/^Windows/.test(part)) {
            os = part;
        } else if (/^CPU/.test(part)) {
            os = (os + " " + part).trim();
        } else if (/^iPhone/.test(part) || /^iPad/.test(part)) {
            os = "iOS";
        } else if (/^Mac/.test(part)) {
            os = "Mac OS X";
        } else if (/^Linux/.test(part)) {
            os = "Linux";
        }

        if (/^CriOS/.test(part)) {
            browser = "Chrome for iOS";
            break;
        } else if (/^Edg/.test(part)) {
            browser = "Edge";
            break;
        } else if (/^OPR/.test(part)) {
            browser = "Opera";
            break;
        } else if (/^Firefox/.test(part)) {
            browser = "Firefox";
            break;
        } else if (/^Chrome/.test(part)) {
            browser = "Chrome";
            break;
        } else if (/^Safari/.test(part) && browser === "") {
            browser = "Safari";
        }
    }

    const groupKey = device + "|" + browser;
    const label = browser ? `${device} · ${browser}` : device;
    return { device, os, browser, groupKey, label };
}
